import {getParkingAvailabilityRate} from '../../../../api/eastCoastDataApi/scenicPlace/parkingAvailabilityRateApi'
import Utils from '../../../../utils/utils'
import CONST from '../../../../utils/const'

const state = {
  allparkingAvailabilityRate: [],
  parkingAvailabilityRate: [],

}

const getters = {
  getAllParkingAvailabilityRate: (state) => {
    return state.allparkingAvailabilityRate
  },
}

const actions = {
  async getParkingAvailabilityRate({commit}, condition ={}) {
    const result = await getParkingAvailabilityRate(condition);
    if(!Utils.isEmptyObject(result) && result.success) {
      commit('parkingAvailabilityRate', result.data)
    }
  },

}

const mutations = {
  parkingAvailabilityRate(state, data) {
    state.allparkingAvailabilityRate = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}